//IE11 swiper js 'startsWith' Polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position){
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
};
}
var swiper = new Swiper('.content-wrap .swiper-pillows', {
  slidesPerView: 1,
  spaceBetween: 0,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  loop: false,
  // init: false,
  navigation: {
    nextEl: '#pillows-next',
    prevEl: '#pillows-prev',
  },
  breakpoints: {       
    1330: {
      slidesPerView: 1,
      spaceBetween: 1,
    }
  }
});

var swiper = new Swiper('.mob-pillows .swiper-pillows', {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '#pillows-next-mob',
    prevEl: '#pillows-prev-mob',
  },
});

var swiper = new Swiper('.swiper-points', {
  slidesPerView: 2,
  spaceBetween: 0,
  loop: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '#points-next',
    prevEl: '#points-prev',
  },
  breakpoints: {       
    1240: {
      slidesPerView: 3,
      spaceBetween: 0,
      slidesPerGroup: 3,
    }
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
});

var swiper = new Swiper('.swiper-points-mob', {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  navigation: {
    nextEl: '#points-next-mob',
    prevEl: '#points-prev-mob',
  },
  breakpoints: {       
    420: {
      slidesPerView: 2,
      spaceBetween: 0,
    }
  },
});

var swiper = new Swiper('.item-image .swiper-container', {
  slidesPerView: 1,
  spaceBetween: 0,
  watchOverflow:true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});
